// extracted by mini-css-extract-plugin
module.exports = {"mb20":"GhanaGov_mb20__3Jxi_"};